import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import ClipLoader from 'react-spinners/ClipLoader';

import Layout from 'components/Layout';
import paths from '../paths';

const PrivateRoute = ({ path, component: Component }) => {
  const { id, restoring } = useSelector(
    (state) => ({
      id: state.auth.userData.id,
      restoring: state.auth.restoring,
    }),
    shallowEqual
  );

  return (
    <Layout>
      <Route
        exact
        path={path}
        render={() => {
          if (restoring) {
            return <ClipLoader />;
          }
          return id ? <Component /> : <Redirect to={paths.LOGIN} />;
        }}
      />
    </Layout>
  );
};

PrivateRoute.propType = {
  path: PropTypes.string.isRequired,
  component: PropTypes.element.isRequired,
};

export default PrivateRoute;
